// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__PoU0m","inputWrap":"styles_inputWrap__3Syiz","input":"styles_input__3mADx"};